import React,  { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
// Schriften selbst ausliefern statt von Google Fonts (keine IP-Übermittlung an Google)
import '@fontsource/dm-sans/latin-200.css';
import '@fontsource/dm-sans/latin-300.css';
import '@fontsource/dm-sans/latin-400.css';
import '@fontsource/dm-sans/latin-500.css';
import '@fontsource/dm-sans/latin-600.css';
import '@fontsource/outfit/latin-800.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { leistungErfassen } from './utils/nutzung';
import { zahlenfelderMarkieren } from './utils/zahlenfelder';
import store from './app/store'
import { Provider } from 'react-redux'
import SuspenseContent from './containers/SuspenseContent';
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1cdnVXR2dYVUF2WUo=');

zahlenfelderMarkieren();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Suspense fallback={<SuspenseContent />}>
        <Provider store={store}>
            <App />
        </Provider>
    </Suspense>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(leistungErfassen);
